import { render, staticRenderFns } from "./VE_Exams.vue?vue&type=template&id=b0860ce8&scoped=true&"
import script from "./VE_Exams.vue?vue&type=script&lang=js&"
export * from "./VE_Exams.vue?vue&type=script&lang=js&"
import style0 from "./VE_Exams.vue?vue&type=style&index=0&id=b0860ce8&scoped=true&lang=scss&"
import style1 from "./VE_Exams.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0860ce8",
  null
  
)

export default component.exports